<template>
  <v-menu :close-on-content-click="false" offset-y>
    <template #activator="{ on, attrs }">
      <v-btn v-bind="attrs" :class="buttonClass" v-on="on">
        <v-icon :color="internalValue">{{ icon }}</v-icon>
        {{ label }}
      </v-btn>
    </template>
    <v-color-picker
      id="v-color-pick"
      v-model="internalValue" value="hex"
      @input="handleValueChange"
    ></v-color-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'ColorPicker',
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    buttonClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    handleValueChange(newValue) {
      this.internalValue = newValue
    }
  }
}
</script>
